/**
 * Generate a data URL SVG avatar with initials
 * Creates a circular avatar with a random background color and contrasting text
 *
 * @param text - The text to extract initials from (e.g., email or username)
 * @returns Data URL string for the SVG avatar
 */
export function generateInitialsAvatar(text: string): string {
  // Extract initials from text (first and last characters before @)
  const username = text.split('@')[0];
  const initials = username.length >= 2
    ? (username[0] + username[username.length - 1]).toUpperCase()
    : username[0].toUpperCase();

  // Generate a consistent color based on the text
  const hue = hashStringToHue(text);
  const backgroundColor = `hsl(${hue}, 70%, 60%)`;

  // Use white text for better contrast on most background colors
  const textColor = '#ffffff';

  // Create SVG
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 128 128">
  <circle cx="64" cy="64" r="64" fill="${backgroundColor}"/>
  <text x="64" y="64" text-anchor="middle" dominant-baseline="central" font-family="system-ui, -apple-system, sans-serif" font-size="48" font-weight="600" fill="${textColor}">${initials}</text>
</svg>`;

  // Convert to data URL (browser-safe, no Buffer needed)
  const base64 = btoa(svg);
  return `data:image/svg+xml;base64,${base64}`;
}

/**
 * Hash a string to a hue value (0-360)
 * Ensures consistent colors for the same input
 */
function hashStringToHue(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash % 360);
}
